import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import DialogMessages from "./modules/Dialog/index";
import Configs from "./modules/Configs/index";
import Setting from './modules/Setting/index'
import Authentication from "./modules/Authentication/index";

import EPortCourse from "./modules/EPorts/coruse";
import Campus from "@/store/modules/Configs/campus";
import Course from "@/store/modules/Education/Course";
import Facultys from "@/store/modules/Education/Facultys";
import Departments from "@/store/modules/Education/Departments";

import EProtMapping from "@/store/modules/EPorts/mapping";


import Members from "@/store/modules/Members/index";


import Assessment from "@/store/modules/Assessment/index";




import Organization from "@/store/modules/Hr/Organization/index";
import Agency from "@/store/modules/Hr/Agency/index";

import AgencyChart from "@/store/modules/Hr/AgencyChart/index";

import Personal from "@/store/modules/Hr/Personnel/index";
import Estimate from "@/store/modules/Hr/Estimate/index";

import Accounts_Role from "@/store/modules/Hr/Accounts_Role/index";

import Idp from "@/store/modules/idp/index";
import idpReport from "@/store/modules/idp/reports/index";

import Report from "@/store/modules/Reports/index";
import RMethod from "@/store/modules/Reports/method";


const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  asideShow: false,
  darkMode: false,

  XAccessToken: null,
  accounts:null
}

const mutations = {
  xAccessToken(state, objs) {
    state.XAccessToken = objs;
  },

  accounts(state, objs) {
    state.accounts = objs;
  },



  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  toggle (state, variable) {
    state[variable] = !state[variable]
  }
}


export default new Vuex.Store({
  state,
  mutations,
  modules : {
    dialog: DialogMessages,
    config : Configs,
    auth : Authentication,
    setting : Setting,

    member : Members,

    assessment : Assessment,


    campus : Campus,
    courses : Course,
    faculty : Facultys,
    departent : Departments,

    EProtCourse : EPortCourse,
    EProtMapping : EProtMapping,


    // hr
    organization : Organization,
    agency : Agency,
    agencyChart : AgencyChart,



    // yourself
    personal : Personal,
    admin : Accounts_Role,
    estimate : Estimate,

    idp:Idp,
    idpReport:idpReport,

    report : Report,
    rMethod : RMethod

  }
});
